import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "fourByFour"
const FourByFourIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12.924 5.438C13.238 5.438 13.531 5.594 13.704 5.855L15.71 8.863 20.918 9.783C21.724 9.924 22.313 10.624 22.313 11.443V15C22.313 15.518 21.893 15.938 21.375 15.938H20.564C20.306 17.117 19.257 18 18 18S15.694 17.117 15.437 15.938H10.439C10.18 17.117 9.131 18 7.874 18S5.569 17.117 5.312 15.938H4.125C3.607 15.938 3.188 15.518 3.188 15V12.938H2.625C2.107 12.938 1.688 12.518 1.688 12V8.625C1.688 8.107 2.108 7.688 2.625 7.688H4.045L4.874 5.968 4.939 5.854C5.112 5.596 5.403 5.438 5.718 5.438zM7.875 14.25C7.254 14.25 6.75 14.754 6.75 15.375S7.254 16.5 7.875 16.5 9 15.996 9 15.375 8.496 14.25 7.875 14.25M18 14.25C17.379 14.25 16.875 14.754 16.875 15.375S17.379 16.5 18 16.5 19.125 15.996 19.125 15.375 18.621 14.25 18 14.25M14.383 11.163C14.207 11.339 13.968 11.437 13.72 11.437H11.75C11.547 11.438 11.35 11.373 11.188 11.25L9.938 10.313H4.312V11.813H4.876C5.185 11.813 5.438 12.064 5.438 12.375 5.438 12.685 5.186 12.938 4.875 12.938H4.313V14.812H5.312C5.569 13.634 6.618 12.75 7.875 12.75S10.181 13.633 10.438 14.813H15.438C15.694 13.633 16.743 12.75 18 12.75S20.306 13.633 20.564 14.813H21.188V13.313H21C20.69 13.313 20.438 13.06 20.438 12.75S20.689 12.188 21 12.188H21.188V11.444C21.188 11.171 20.99 10.937 20.722 10.89L15.565 9.98zM2.813 11.813H3.187V9.633L3.235 9.528 3.543 8.813H2.813zM10.686 9.469 11.814 10.313H13.643L14.65 9.303 12.824 6.563H10.688zM4.917 8.473 4.606 9.187H9.564V6.563H5.835z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default FourByFourIcon
